/**
 * Скрипты для попапов
 */
var popup = function () {
    var $html = $('html');
    var $popups = $('.js-popup');

    var init = function () {
        initEvent();
        initPhoneMask();
    };

    /**
     * Инициализация событий
     */
    var initEvent = function () {
        $(document).on('click', '.js-popup-open', function (event){
            var $target = $(event.target).closest('.js-popup-open');

            $('html').removeClass('fixed');
            closeAllPopup();

            var targetSelector;
            if ($target.data('target')) {
                targetSelector = $target.data('target');
            }

            if (targetSelector) {
                var $popup = $(document).find(targetSelector);
                open($popup);

                var $form = $popup.find('.js-form');
                if ($form) {
                    clearForm();
                }
            }
        });
    };

    /**
     * Открываем попап, предварительно закрыв все сотальные
     */
    var open = function ($element) {
        restoreHandlers($element);
        $element.addClass('open');
        $html.addClass('fixed');
    };

    /**
     * Очищаем поля формы
     */
    function clearForm(el) {
        $(el).find("input[type=text], textarea, select").val("");
    }

    /**
     * 1) Убивает обработчики;
     * 2) Скрываем все попапы
     */
    var close = function ($element){
        destroyHandlers($element);
        $html.removeClass('fixed');
        $popups.each(function (index, element) {
            $(element).removeClass('open');
        });
        window.dispatchEvent(new CustomEvent('close-popup'));
    };

    /**
     * Инициализирует обработчики
     */
    var restoreHandlers = function($element) {
        $element.on('mousedown', onEmptyAreaClick);
        $element.find('.js-popup-close').on('click', onCloseButton);
    };

    /**
     * Обработчик клика на крестик
     */
    var onCloseButton = function (evt){
        var $popup = $(evt.target).closest('.js-popup');
        close($popup);
    };

    /**
     * Обработчик клика на пустую область
     */
    var onEmptyAreaClick = function (evt){
        var $popup = $(evt.target).closest('.js-popup');
        if (evt.target === $popup.get(0)) {
            close($popup);
        }
    };

    /**
     * Убивает обработчики
     */
    var destroyHandlers = function ($element) {
        $element.find('.js-popup-close').off('click', onCloseButton);
        $element.off('mousedown', onEmptyAreaClick);
    };

    /**
     * Закрываем все попапы
     */
    var closeAllPopup = function () {
        $popups.each(function (index, element){
            $(element).removeClass('open');
        });
    };


    /**
     *  Инициализация маски телефона
     */
    var initPhoneMask = function () {
        var $phoneInput = $popups.find('.js-input-phone-mask');
        $phoneInput.inputmask('+7(999)999-99-99', {
            placeholder: '+7(___)___-__-__',
        });
    };

    init();
};

